/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Players_HintInputs */

const th_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค่ายฝึกและงานแสดงความสามารถรับสมัครผู้เล่นรายบุคคล`)
};

const en_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps and showcases are entered by individual players.`)
};

const ja_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンプとショーケースは個人単位で申し込みます。`)
};

const zh_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在训练营和展示赛中，球员单独报名。`)
};

const es_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En los campus y exhibiciones se inscriben los jugadores de forma individual.`)
};

const pt_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em clínicas e showcases quem se inscreve são os jogadores individualmente.`)
};

const id_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk kamp dan showcase, pemain mendaftar sendiri-sendiri.`)
};

const fr_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aux stages et showcases, ce sont les joueurs qui s’inscrivent individuellement.`)
};

const tl_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa mga camp at showcase, isa-isang nagrerehistro ang mga manlalaro.`)
};

const vi_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ở trại tập và showcase, cầu thủ đăng ký riêng từng người.`)
};

const ko_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캠프와 쇼케이스에서는 선수가 개별적으로 등록합니다.`)
};

const de_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Camps und Showcases melden sich die Spieler einzeln an.`)
};

const ru_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В лагерях и шоукейсах игроки заявляются по одному.`)
};

const tr_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamplarda ve showcase'lerde oyuncular tek tek kaydolur.`)
};

const it_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nei camp e negli showcase i giocatori si iscrivono singolarmente.`)
};

const pl_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na obozach i pokazach zawodnicy zapisują się pojedynczo.`)
};

const uk_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У таборах і шоукейсах гравці заявляються поодинці.`)
};

const hi_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैंप और शोकेस में खिलाड़ी अलग-अलग पंजीकरण कराते हैं।`)
};

const ar_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في المعسكرات والعروض يسجّل اللاعبون فرادى.`)
};

const ms_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam kem dan showcase, pemain mendaftar seorang demi seorang.`)
};

const bn_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যাম্প ও শোকেসে খেলোয়াড়েরা আলাদাভাবে নিবন্ধন করেন।`)
};

const zh_tw2_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在訓練營與觀摩賽中，球員各自報名。`)
};

const zh_hk2_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在訓練營與表演賽中，球員各自報名。`)
};

const ur_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیمپ اور شوکیس میں کھلاڑی الگ الگ رجسٹر ہوتے ہیں۔`)
};

const fa_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در اردوها و نمایش‌ها بازیکنان جداگانه ثبت‌نام می‌کنند.`)
};

const sw_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwenye kambi na maonyesho, wachezaji hujisajili mmoja mmoja.`)
};

const nl_event_players_hint = /** @type {(inputs: Event_Players_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bij kampen en showcases schrijven spelers zich afzonderlijk in.`)
};

/**
* | output |
* | --- |
* | "Camps and showcases are entered by individual players." |
*
* @param {Event_Players_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_players_hint = /** @type {((inputs?: Event_Players_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Players_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_players_hint(inputs)
	if (locale === "ja") return ja_event_players_hint(inputs)
	if (locale === "zh") return zh_event_players_hint(inputs)
	if (locale === "es") return es_event_players_hint(inputs)
	if (locale === "pt") return pt_event_players_hint(inputs)
	if (locale === "id") return id_event_players_hint(inputs)
	if (locale === "fr") return fr_event_players_hint(inputs)
	if (locale === "tl") return tl_event_players_hint(inputs)
	if (locale === "vi") return vi_event_players_hint(inputs)
	if (locale === "ko") return ko_event_players_hint(inputs)
	if (locale === "de") return de_event_players_hint(inputs)
	if (locale === "ru") return ru_event_players_hint(inputs)
	if (locale === "tr") return tr_event_players_hint(inputs)
	if (locale === "it") return it_event_players_hint(inputs)
	if (locale === "pl") return pl_event_players_hint(inputs)
	if (locale === "uk") return uk_event_players_hint(inputs)
	if (locale === "hi") return hi_event_players_hint(inputs)
	if (locale === "ar") return ar_event_players_hint(inputs)
	if (locale === "ms") return ms_event_players_hint(inputs)
	if (locale === "bn") return bn_event_players_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_event_players_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_event_players_hint(inputs)
	if (locale === "ur") return ur_event_players_hint(inputs)
	if (locale === "fa") return fa_event_players_hint(inputs)
	if (locale === "sw") return sw_event_players_hint(inputs)
	if (locale === "nl") return nl_event_players_hint(inputs)
	return en_event_players_hint(inputs)
});